import { createContext } from "react";

const APIsHandlerContext = createContext();

const APIsHandler = (props) => {    
    const apiUrl = 'https://50ta7xp4hi.execute-api.us-east-2.amazonaws.com/dev' //portal-fanttech

    async function newDeviceAPIPost(username, deviceID) {
        const request = 0;
        const criadoEm = "16/08/1999";
        const novoDevice = { request, username, deviceID, criadoEm };
        const raw = JSON.stringify(novoDevice);
        console.log(`raw = ${raw}`);
        const requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: raw
        };
        const resp = fetch(apiUrl, requestOptions);
        return resp;
    }

    async function newShapefileAPIPost(username, shapefileUUID, deviceID, filename) {
        const request = 3;
        const novoShapefile = { request, username, shapefileUUID, deviceID, filename };
        const raw = JSON.stringify(novoShapefile);
        console.log(`raw = ${raw}`);
        const requestOptions = {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: raw
        };
        const resp = fetch(apiUrl, requestOptions);
        return resp;
    }
    async function getDeviceMaps (username, deviceID) {
        console.log("API = ", apiUrl + "?request=3&username=" + username + "&deviceID=" + deviceID)
        const resp = fetch(apiUrl + "?request=3&username=" + username + "&deviceID=" + deviceID)
        return resp;
      }
    async function getUserDevicesAPI (username) {
        const resp = fetch(apiUrl + "?request=0&username=" + username);
        return resp;
    }

    async function getDevicesFieldsAPI (deviceID) {
        const resp = fetch(apiUrl + "?request=1&deviceID=" + deviceID);
        return resp;
    }

    async function getFieldEventsAPI (campoID) {
        const resp = fetch(apiUrl + "?request=2&campoUUID=" + campoID);
        return resp;
    }

    async function getEventPolygonsAPI (eventoID) {
        const resp = fetch(apiUrl + "?request=3&eventoUUID=" + eventoID);
        return resp;
    }

    async function removeShapefileAPI (username, shapefileUUID) {
        console.log("API = ", apiUrl + "?request=4&username=" + username + "&shapefileUUID=" + shapefileUUID);
        const resp = fetch(apiUrl + "?request=4&username=" + username + "&shapefileUUID=" + shapefileUUID);
        return resp;
    }

    async function getVehiclesAPI (deviceID) {
        const resp = fetch(apiUrl + "?request=5&deviceID=" + deviceID);
        return resp;
    }

    async function getImplementsAPI (deviceID) {
        const resp = fetch(apiUrl + "?request=6&deviceID=" + deviceID);
        return resp;
    }

    return (
        <APIsHandlerContext.Provider value={
            { 
                newDeviceAPIPost, 
                newShapefileAPIPost,
                getUserDevicesAPI, 
                getDevicesFieldsAPI, 
                getFieldEventsAPI, 
                getEventPolygonsAPI,
                getDeviceMaps,
                getVehiclesAPI,
                getImplementsAPI,
                removeShapefileAPI
            }}>
            {props.children}
        </APIsHandlerContext.Provider>
    );
}
 
export { APIsHandler, APIsHandlerContext };